// If you want to add a new Sentry pages/error,
// please see the folder: libs/common-next/src/constants/sentry

// TODO: Refactor this file to use the new Sentry error structure
export const PAGES = {
    cart: 'CART_PAGE',
    cartOrCheckout: 'CART_OR_CHECKOUT_PAGE',
    checkout: 'CHECKOUT_PAGE',
    checkoutLogin: 'CHECKOUT_LOGIN_PAGE',
    orderConfirmation: 'ORDER_CONFIRMATION_PAGE',
};

export const SENTRY_EVENTS = {
    EMPTY_CART_PAGE_LOADED: {
        page: PAGES.cart,
        action: 'EMPTY_CART_PAGE_LOADED',
    },
    CART_PAGE_LOADED: { page: PAGES.cart, action: 'CART_PAGE_LOADED' },
    CHECKOUT_PAGE_LOADED: {
        page: PAGES.checkout,
        action: 'CHECKOUT_PAGE_LOADED',
    },
    CHECKOUT_LOGIN_PAGE_LOADED: {
        page: PAGES.checkoutLogin,
        action: 'CHECKOUT_LOGIN_PAGE_LOADED',
    },
    ORDER_CONFIRMATION_PAGE_LOADED: {
        page: PAGES.orderConfirmation,
        action: 'ORDER_CONFIRMATION_PAGE_LOADED',
    },
    NAVIGATE_TO_CHECKOUT: { page: PAGES.cart, action: 'NAVIGATE_TO_CHECKOUT' },
    CC_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'CC_ORDER_CLICK',
    },
    AFTERPAY_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'AFTERPAY_ORDER_CLICK',
    },
    AFTERPAY_PAYMENT_SUBMIT: {
        page: PAGES.checkout,
        action: 'AFTERPAY_PAYMENT_SUBMIT',
    },
    AFTERPAY_ADDITIONAL_DETAILS: {
        page: PAGES.checkout,
        action: 'ADDITIONAL_DETAILS',
    },
    AFTERPAY_REDIRECT_RETURN: {
        page: PAGES.checkout,
        action: 'AFTERPAY_REDIRECT_RETURN',
    },
    PAYPAL_ORDER_CLICK: {
        page: PAGES.checkout,
        action: 'PAYPAL_ORDER_CLICK',
    },
    PAYPAL_INITIALIZED: {
        page: PAGES.checkout,
        action: 'PAYPAL_INITIALIZED',
    },
    PAYPAL_ADDITIONAL_DETAILS: {
        page: PAGES.checkout,
        action: 'ADDITIONAL_DETAILS',
    },
    PAYPAL_REDIRECT_RETURN: {
        page: PAGES.checkout,
        action: 'PAYPAL_REDIRECT_RETURN',
    },
    CHANGE_FULFILLMENT_METHOD: {
        page: PAGES.cart,
        action: 'CHANGE_FULFILLMENT_METHOD',
    },
    SAVE_AUTOSHIP_METHOD: {
        page: PAGES.cart,
        action: 'SAVE_AUTOSHIP_METHOD',
    },
    REMOVE_AUTOSHIP_METHOD: {
        page: PAGES.cart,
        action: 'REMOVE_AUTOSHIP_METHOD',
    },
    MOVE_TO_NEXT_AUTOSHIP: {
        page: PAGES.cart,
        action: 'MOVE_TO_NEXT_AUTOSHIP',
    },
    GET_NEXT_RECURRING_ORDER: {
        page: PAGES.cart,
        action: 'GET_NEXT_RECURRING_ORDER',
    },
    SAVE_SCHEDULED_DELIVERY_DATE: {
        page: PAGES.cart,
        action: 'SAVE_SCHEDULED_DELIVERY_DATE',
    },
    ORDER_PLACED: {
        page: PAGES.checkout,
        action: 'ORDER_PLACED',
    },
};

export const SENTRY_ERRORS = {
    NAVIGATE_TO_CHECKOUT_FAILED: {
        page: PAGES.cart,
        action: 'NAVIGATE_TO_CHECKOUT_FAILED',
    },
    CART_VALIDATION_ERROR: {
        page: PAGES.cartOrCheckout,
        action: 'CART_VALIDATION_ERROR',
    },
    CART_VALIDATE_OR_REDIRECT_ERROR: {
        page: PAGES.cartOrCheckout,
        action: 'CART_VALIDATE_OR_REDIRECT_ERROR',
    },
    CART_ADD_ITEM_ERROR: {
        page: PAGES.cart,
        action: 'CART_ADD_ITEM_ERROR',
    },
    CART_FETCH_STORES_ERROR: {
        page: PAGES.cart,
        action: 'CART_FETCH_STORES_ERROR',
    },
    CART_CHANGE_FM_ERROR: {
        page: PAGES.cart,
        action: 'CART_CHANGE_FM_ERROR',
    },
    CART_CHANGE_SCHEDULED_DELIVERY_DATE_ERROR: {
        page: PAGES.cart,
        action: 'CART_CHANGE_SCHEDULED_DELIVERY_DATE_ERROR',
    },
    CART_MISMATCHING_PAYLOAD: {
        page: PAGES.cart,
        action: 'CART_MISMATCHING_PAYLOAD',
    },
    CC_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'CC_ORDER_ERROR',
    },
    AFTERPAY_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'AFTERPAY_ORDER_ERROR',
    },
    AFTERPAY_PLACE_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'AFTERPAY_PLACE_ORDER_ERROR',
    },
    AFTERPAY_USER_CANCELLED: {
        page: PAGES.checkout,
        action: 'AFTERPAY_USER_CANCELLED',
    },
    AFTERPAY_PAYMENT_REFUSED: {
        page: PAGES.checkout,
        action: 'AFTERPAY_PAYMENT_REFUSED',
    },
    AFTERPAY_CHECKOUT_COMPONENT_ERROR: {
        page: PAGES.checkout,
        action: 'AFTERPAY_CHECKOUT_COMPONENT_ERROR',
    },
    PAYPAL_ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'PAYPAL_ORDER_ERROR',
    },
    PAYPAL_USER_CANCELLED: {
        page: PAGES.checkout,
        action: 'PAYPAL_USER_CANCELLED',
    },
    PAYPAL_PAYMENT_REFUSED: {
        page: PAGES.checkout,
        action: 'PAYPAL_PAYMENT_REFUSED',
    },
    PAYPAL_CHECKOUT_COMPONENT_ERROR: {
        page: PAGES.checkout,
        action: 'PAYPAL_CHECKOUT_COMPONENT_ERROR',
    },
    ORDER_ERROR: {
        page: PAGES.checkout,
        action: 'ORDER_ERROR',
    },
};

export const SENTRY_CONTEXT = {
    ...SENTRY_EVENTS,
    ...SENTRY_ERRORS,
};

export type SentryContextKey = keyof typeof SENTRY_CONTEXT;
export type SentryContextType = (typeof SENTRY_CONTEXT)[SentryContextKey];
